import styled from "styled-components";

export const ParticipantsMainWrapper = styled.div``;
